import React from 'react';
import PropTypes from 'prop-types';
import UserRow from './UserRow';
import _ from 'lodash';
import { I18nUtils } from '../../../i18n/I18nUtils';
import { PsTable } from '../../shared/components/table/PsTable';
import { PsUser } from '../../shared/model/PsUser';

export default class UsersTable extends React.Component {

    renderHead() {
        return (
            <tr>
                <th>{I18nUtils.tr('TR_ESTADO')}</th>
                <th>{I18nUtils.tr('TR_ROL')}</th>
                <th>{I18nUtils.tr('TR_NOMBRE')}</th>
                <th>{I18nUtils.tr('TR_APELLIDO_S')}</th>
                <th>{I18nUtils.tr('TR_EMAIL')}</th>
                <th>{I18nUtils.tr('TR_EMPRESA')}</th>
                <th/>
            </tr>
        );
    }

    render() {
        const { error, data } = this.props;

        if ( error ) {
            return (
                <section className={'error-section'}>
                    <h3 className={'text-center'}>{error}</h3>
                </section>
            );
        }

        if ( !data || data.length === 0 ) {
            return null;
        }

        return (
            <PsTable headings={this.renderHead()}>
                {
                    _.map(data, (user) =>
                        <UserRow
                            key={user.id}
                            user={PsUser.fromBackend(user)}
                        />,
                    )
                }
            </PsTable>
        );
    }

}

UsersTable.propTypes = {
    data: PropTypes.any,
    error: PropTypes.string,
};

UsersTable.defaultProps = {
    data: {},
};



// WEBPACK FOOTER //
// ./src/app/users/components/UsersTable.jsx